// ============================================================
// VALLERJE — Painting Commission: data, pricing, Klaviyo
// Loaded first. Everything here is read by the components and
// step files that follow.
// ============================================================

function vljCfg() {
  return (typeof window !== "undefined" && window.VLJ_COMMISSION_CONFIG) || {};
}

// ── Size packages ───────────────────────────────────────────
// Prices are authored in the shop's base currency (USD) and converted
// for display via Shopify's presentment rate. Overridable in the theme editor.

const DEFAULT_SIZES = [
  { id: "small",  name: "Small",  dimsCm: "30–40 × 40–50 cm",    dimsIn: "12–16 × 16–20 in", price: 399,
    blurb: "A focused single-character piece. Sits beautifully on a shelf, a desk, or in a gallery wall cluster." },
  { id: "medium", name: "Medium", dimsCm: "50–60 × 60–80 cm",    dimsIn: "20–24 × 24–31 in", price: 599,
    blurb: "The most popular size. Enough room for real background detail without taking over the wall.",
    badge: "Most popular" },
  { id: "large",  name: "Large",  dimsCm: "70–80 × 90–110 cm",   dimsIn: "28–31 × 35–43 in", price: 899,
    blurb: "A statement piece. Full scene work, layered depth, the kind of canvas people walk up to." },
  { id: "grand",  name: "Grand",  dimsCm: "100–120 × 130–160 cm", dimsIn: "39–47 × 51–63 in", price: 1200,
    blurb: "Floor-to-eye scale, maximum detail, built to own the room it hangs in." }
];

function VLJ_SIZES() {
  const cfg = vljCfg();
  return Array.isArray(cfg.sizes) && cfg.sizes.length ? cfg.sizes : DEFAULT_SIZES;
}

function VLJ_PRICING() {
  const cfg = vljCfg();
  const p = cfg.pricing || {};
  return {
    extraCharacterPrice: typeof p.extraCharacterPrice === "number" ? p.extraCharacterPrice : 150,
    includedCharacters: typeof p.includedCharacters === "number" ? p.includedCharacters : 1,
    maxCharacters: typeof p.maxCharacters === "number" ? p.maxCharacters : 6
  };
}

const ANIME_SUGGESTIONS = [
  "Bleach", "DanDaDan", "Solo Leveling", "Jujutsu Kaisen", "One Piece", "Naruto",
  "Dragon Ball", "Attack on Titan", "Demon Slayer", "Hunter x Hunter", "One Punch Man",
  "Chainsaw Man", "Blue Lock", "Tokyo Revengers", "Vinland Saga", "Mob Psycho 100",
  "Berserk", "Cowboy Bebop", "Evangelion", "Death Note"
];

const COUNTRIES = [
  "Sweden", "Norway", "Denmark", "Finland", "Germany", "Netherlands", "Belgium",
  "France", "Spain", "Italy", "Portugal", "Austria", "Switzerland", "Poland",
  "United Kingdom", "Ireland", "United States", "Canada", "Australia", "New Zealand",
  "Japan", "Singapore", "United Arab Emirates", "Other"
];

const SOCIAL_PLATFORMS = ["Instagram", "TikTok", "Twitter / X", "Discord", "None"];

const STEP_LABELS = ["Start", "Size", "Vision", "Characters", "Details", "Review"];

const REVIEW_STEP = 5;
const CONFIRM_STEP = 99;

// ── Copy that the artist can edit from the theme editor ─────

const DEFAULT_TRUST_POINTS = [
  "Hand-painted originals — one of one, never reprinted",
  "Worldwide shipping included in every commission",
  "Progress photos at every stage, from sketch to sealed",
  "Sketch approved by you before any paint touches canvas"
];

const DEFAULT_FAQ_ITEMS = [
  { q: "How does the price work?",
    a: "The size you pick sets the base price, and that already includes one character and worldwide shipping. Every additional character adds a fixed amount, so the number you see at the end is the number I quote you." },
  { q: "Is the price at the end final?",
    a: "It's the real price for what you've specified. I confirm it in my reply — if something in your brief needs more than a standard build, I'll say so before anything is agreed." },
  { q: "How long does a commission take?",
    a: "Most pieces take 4–6 weeks from approved sketch to shipped, depending on size and how many characters are in the composition. I'll give you a firm date when I reply." },
  { q: "What happens after I send this?",
    a: "I read the brief personally and reply by email, usually within 24 hours. We lock the direction, I send a sketch for approval, and only then does painting start." },
  { q: "Can you paint any anime or theme?",
    a: "Any anime, game, film or original idea. The theme field is there so I know the world we're working in — the references you link tell me the rest." },
  { q: "What do you paint on?",
    a: "Professional-grade stretched canvas, painted edge to edge and finished with a protective sealer so it holds its colour for decades." },
  { q: "Why is the size given as a range?",
    a: "Because the composition decides the final proportions. A tall single figure and a wide battle scene want different shapes, so I work within the range you pick and we agree the exact dimensions together before I start. The price is the same anywhere in the range." },
  { q: "Do you ship internationally?",
    a: "Yes, and shipping is already included in the price you see — wherever you are. Paintings ship rolled or stretched depending on size and destination, always tracked and insured." },
  { q: "Can I change my mind after submitting?",
    a: "Of course. Nothing is locked in by sending this form — it starts a conversation. We adjust size, characters or direction freely until you approve the sketch." }
];

function VLJ_TRUST_POINTS() {
  const cfg = vljCfg();
  return Array.isArray(cfg.trustPoints) && cfg.trustPoints.length ? cfg.trustPoints : DEFAULT_TRUST_POINTS;
}

function VLJ_FAQ_ITEMS() {
  const cfg = vljCfg();
  return Array.isArray(cfg.faqItems) && cfg.faqItems.length ? cfg.faqItems : DEFAULT_FAQ_ITEMS;
}

function VLJ_TESTIMONIALS() {
  const cfg = vljCfg();
  return Array.isArray(cfg.testimonials) ? cfg.testimonials : [];
}

// ── Currency ────────────────────────────────────────────────
// Prices are authored in cfg.priceCurrency (the shop's base currency).
// Shopify exposes window.Shopify.currency = { active, rate } where `rate`
// converts the shop's base currency into the visitor's presentment currency.

function vljMarket() {
  return (typeof window !== "undefined" && window.Shopify && window.Shopify.currency) || null;
}

function activeCurrency() {
  const cfg = vljCfg();
  const market = vljMarket();
  const authored = String(cfg.priceCurrency || "USD").toUpperCase();
  const base = String(cfg.shopBaseCurrency || authored).toUpperCase();
  // When prices aren't authored in the shop's base currency we can't convert
  // them (see currencyRate). Label them in the currency they were actually
  // written in, so a misconfigured store shows "$1,200" rather than the same
  // digits relabelled as another currency.
  if (authored !== base) return authored;
  return String((market && market.active) || cfg.currency || authored).toUpperCase();
}

function currencyRate() {
  const cfg = vljCfg();
  const market = vljMarket();
  const authored = String(cfg.priceCurrency || "USD").toUpperCase();
  const base = String(cfg.shopBaseCurrency || authored).toUpperCase();
  // Prices must be authored in the shop's base currency for the presentment
  // rate to mean anything. If they aren't, fall back to 1:1 rather than
  // silently multiplying by a rate that describes a different currency pair.
  if (authored !== base) return 1;
  const rate = market && parseFloat(market.rate);
  return isFinite(rate) && rate > 0 ? rate : 1;
}

// Converts one authored amount into the visitor's currency.
// Every displayed figure goes through this, and totals are summed from
// already-converted parts, so a breakdown always adds up to its total.
function convert(amount) {
  const rate = currencyRate();
  const converted = (Number(amount) || 0) * rate;
  if (rate === 1) return Math.round(converted);
  // Converted figures land on ugly numbers; nudge to the nearest 5 so a
  // quote reads like a price rather than an exchange-rate artefact.
  return Math.round(converted / 5) * 5;
}

function formatMoney(amount, options) {
  const opts = options || {};
  const currency = opts.currency || activeCurrency();
  const localeByCurrency = {
    USD: "en-US", EUR: "de-DE", GBP: "en-GB", SEK: "sv-SE", NOK: "nb-NO",
    DKK: "da-DK", JPY: "ja-JP", CAD: "en-CA", AUD: "en-AU", CHF: "de-CH",
    PLN: "pl-PL", SGD: "en-SG", AED: "en-AE", NZD: "en-NZ"
  };
  const locale = localeByCurrency[currency] || "en-US";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(amount || 0);
  } catch (e) {
    return Math.round(amount || 0).toLocaleString() + " " + currency;
  }
}

// Convert + format in one call — what the UI actually uses.
function price(amount) {
  return formatMoney(convert(amount));
}

// ── Quote engine ────────────────────────────────────────────
// Returns everything in the visitor's currency, with the total summed
// from the same converted numbers shown in the breakdown.

function buildQuote(formData) {
  const sizes = VLJ_SIZES();
  const pricing = VLJ_PRICING();
  const size = sizes.find(s => s.id === formData.size) || null;
  const characters = Math.max(1, Number(formData.characters) || 1);
  const extraCharacters = Math.max(0, characters - pricing.includedCharacters);

  const baseConverted = size ? convert(size.price) : 0;
  const perCharacterConverted = convert(pricing.extraCharacterPrice);
  const charactersConverted = perCharacterConverted * extraCharacters;
  const totalConverted = baseConverted + charactersConverted;

  return {
    size: size,
    characters: characters,
    extraCharacters: extraCharacters,
    includedCharacters: pricing.includedCharacters,
    maxCharacters: pricing.maxCharacters,
    currency: activeCurrency(),
    base: baseConverted,
    perCharacter: perCharacterConverted,
    charactersTotal: charactersConverted,
    total: totalConverted,
    baseLabel: formatMoney(baseConverted),
    perCharacterLabel: formatMoney(perCharacterConverted),
    charactersTotalLabel: formatMoney(charactersConverted),
    totalLabel: formatMoney(totalConverted),
    // Authored figures travel with the lead so the artist always sees the
    // price in his own currency, whatever the customer was shown.
    baseAuthored: size ? size.price : 0,
    totalAuthored: (size ? size.price : 0) + pricing.extraCharacterPrice * extraCharacters,
    authoredCurrency: String(vljCfg().priceCurrency || "USD").toUpperCase()
  };
}

// ── Klaviyo ─────────────────────────────────────────────────
// Client-side endpoints, safe with the public company ID.
//  • /client/profiles/      — always: records the lead and its properties
//  • /client/events/        — always: fires the metric a flow can notify you on
//  • /client/subscriptions/ — only when the customer ticks the consent box

const KLAVIYO_REVISION = "2024-10-15";

function klaviyoBase(path) {
  const cfg = vljCfg();
  return "https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(cfg.klaviyoCompanyId || "");
}

function klaviyoPost(path, body) {
  return fetch(klaviyoBase(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      revision: KLAVIYO_REVISION
    },
    body: JSON.stringify(body)
  }).then(res => {
    if (!res.ok && res.status !== 202) {
      return res.text().then(text => {
        throw new Error("Klaviyo " + path + " failed (" + res.status + "): " + text);
      });
    }
    return true;
  });
}

function leadProperties(formData) {
  const quote = buildQuote(formData);
  const links = (formData.referenceLinks || []).map(l => String(l || "").trim()).filter(Boolean);
  const props = {
    "Commission Size": quote.size ? quote.size.name : "",
    "Commission Dimensions": quote.size ? quote.size.dimsCm : "",
    "Character Count": quote.characters,
    "Extra Characters": quote.extraCharacters,
    "Theme": formData.theme || "",
    "Scene Description": formData.sceneDescription || "",
    "Reference Links": links.join("\n"),
    "Reference Link Count": links.length,
    "Quoted Total": quote.totalAuthored,
    "Quoted Currency": quote.authoredCurrency,
    "Quoted Total Shown To Customer": quote.totalLabel,
    "Shown Currency": quote.currency,
    "Shipping": "Included in quoted price",
    "Country": formData.country || "",
    "Social Handle": formData.socialHandle ? formData.socialPlatform + ": " + formData.socialHandle : "",
    "Submitted At": new Date().toISOString(),
    "Source": "Custom painting commission form"
  };
  return props;
}

function profileAttributes(formData) {
  const name = String(formData.name || "").trim();
  const parts = name.split(/\s+/);
  const attrs = {
    email: String(formData.email || "").trim(),
    properties: leadProperties(formData)
  };
  if (parts[0]) attrs.first_name = parts[0];
  if (parts.length > 1) attrs.last_name = parts.slice(1).join(" ");
  if (formData.country) attrs.location = { country: formData.country };
  return attrs;
}

// ── Email notification ──────────────────────────────────────
// Posts the brief through Shopify's own contact form, which emails the
// store's contact address. No third-party account, no API keys, and the
// customer's address lands in reply-to so you can answer them directly.

function buildEmailBody(formData) {
  const quote = buildQuote(formData);
  const links = (formData.referenceLinks || []).map(l => String(l || "").trim()).filter(Boolean);
  const lines = [];

  lines.push("NEW PAINTING COMMISSION REQUEST");
  lines.push("");
  lines.push("— THE PIECE —");
  lines.push("Size package:    " + (quote.size ? quote.size.name : "—"));
  lines.push("Size range:      " + (quote.size ? quote.size.dimsCm + "  (" + quote.size.dimsIn + ")" : "—"));
  lines.push("Characters:      " + quote.characters +
    (quote.extraCharacters > 0 ? "  (" + quote.includedCharacters + " included + " + quote.extraCharacters + " extra)" : "  (included)"));
  lines.push("Theme:           " + (formData.theme || "—"));
  lines.push("");
  lines.push("— THE SCENE —");
  lines.push(formData.sceneDescription ? formData.sceneDescription : "(no description given)");
  lines.push("");
  lines.push("— REFERENCES —");
  if (links.length) {
    links.forEach((l, i) => lines.push((i + 1) + ". " + l));
  } else {
    lines.push("(no links given)");
  }
  lines.push("");
  lines.push("— QUOTED PRICE —");
  lines.push("Base (" + (quote.size ? quote.size.name : "—") + "):" + "   " + quote.baseLabel);
  if (quote.extraCharacters > 0) {
    lines.push("Extra characters: " + quote.charactersTotalLabel +
      "  (" + quote.extraCharacters + " × " + quote.perCharacterLabel + ")");
  }
  lines.push("Shipping:        Included");
  lines.push("TOTAL:           " + quote.totalLabel + (quote.currency !== quote.authoredCurrency
    ? "   [= " + quote.totalAuthored + " " + quote.authoredCurrency + " at your prices]"
    : ""));
  lines.push("");
  lines.push("— CUSTOMER —");
  lines.push("Name:            " + (formData.name || "—"));
  lines.push("Email:           " + (formData.email || "—"));
  lines.push("Country:         " + (formData.country || "—"));
  lines.push("Social:          " + (formData.socialHandle
    ? formData.socialPlatform + " " + formData.socialHandle : "—"));
  lines.push("Marketing opt-in:" + (formData.newsletter ? " yes" : " no"));
  lines.push("");
  lines.push("Submitted " + new Date().toLocaleString());
  lines.push("Reply to this email to answer " + (formData.name || "the customer") + " directly.");

  return lines.join("\n");
}

function sendEmailNotification(formData) {
  // A real HTML <form> without a file input posts as
  // application/x-www-form-urlencoded, not multipart/form-data. Shopify's
  // /contact endpoint expects that and 400s on a FormData body, so this
  // uses URLSearchParams — fetch sets the matching Content-Type for it
  // automatically.
  const body = new URLSearchParams();
  body.set("form_type", "contact");
  body.set("utf8", "\u2713");
  body.set("contact[name]", String(formData.name || "Commission request"));
  body.set("contact[email]", String(formData.email || ""));
  body.set("contact[body]", buildEmailBody(formData));

  return fetch("/contact", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
    // Shopify answers this form with a redirect; we only care that it was accepted.
    redirect: "follow"
  }).then(res => {
    if (!res.ok) throw new Error("Shopify contact form returned " + res.status);
    return true;
  });
}

function submitCommissionLead(formData) {
  const cfg = vljCfg();
  if (!cfg.klaviyoCompanyId) {
    return Promise.reject(new Error("Klaviyo public API key is not configured on this section."));
  }

  const attrs = profileAttributes(formData);

  const profileCall = klaviyoPost("profiles", {
    data: { type: "profile", attributes: attrs }
  });

  const eventCall = klaviyoPost("events", {
    data: {
      type: "event",
      attributes: {
        properties: leadProperties(formData),
        metric: {
          data: { type: "metric", attributes: { name: cfg.klaviyoMetricName || "Requested Painting Commission" } }
        },
        profile: {
          data: { type: "profile", attributes: { email: attrs.email, first_name: attrs.first_name, last_name: attrs.last_name } }
        }
      }
    }
  });

  const calls = [profileCall, eventCall];

  if (formData.newsletter && cfg.klaviyoListId) {
    calls.push(klaviyoPost("subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: attrs.email,
                subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: cfg.klaviyoListId } } }
      }
    }));
  }

  // The email is a notification, not the system of record — if Shopify's
  // contact form is unavailable the brief is still safely in Klaviyo, so a
  // failure here is logged and swallowed rather than shown to the customer.
  const emailCall = cfg.emailNotification === false
    ? Promise.resolve(true)
    : sendEmailNotification(formData).catch(err => {
        console.warn("[Vallerje] email notification failed:", err);
        return true;
      });

  // The profile and the event are what make the lead usable, so the submission
  // only fails if one of those fails. A rejected newsletter opt-in is logged
  // and swallowed — it must never cost the artist a lead.
  return Promise.all([
    profileCall,
    eventCall,
    emailCall,
    calls[2] ? calls[2].catch(err => { console.warn("[Vallerje] newsletter opt-in failed:", err); return true; }) : Promise.resolve(true)
  ]).then(() => true);
}

Object.assign(window, {
  vljCfg, VLJ_SIZES, VLJ_PRICING, VLJ_TRUST_POINTS, VLJ_FAQ_ITEMS, VLJ_TESTIMONIALS,
  ANIME_SUGGESTIONS, COUNTRIES, SOCIAL_PLATFORMS, STEP_LABELS, REVIEW_STEP, CONFIRM_STEP,
  activeCurrency, convert, formatMoney, price, buildQuote, submitCommissionLead,
  buildEmailBody, sendEmailNotification
});
